export default __webpack_public_path__ + "static/media/Aura-Egg__96.3ceb97e4.png";